import { usePageBySlug } from "@/hooks/usePagesDB";
import StaticPageRenderer from "@/components/feature/StaticPageRenderer";
import NotFound from "../NotFound";

export default function ImpressumPage() {
  const { page } = usePageBySlug("impressum");
  if (!page) return null;
  if (!page.isPublished) return <NotFound />;

  return <StaticPageRenderer page={page} />;
}